<template>
  <div>
    <div class="demo-inline-spacing">
      <b-form ref="form" @submit.prevent="repeateAgain">
        <b-row>
          <b-col cols="12"> </b-col>
          <b-col cols="12"> </b-col>

          <b-col cols="12">
            <b-row>
              <b-col cols="7">
                <h6 style="text-align: center">{{ $t("ProductGroup") }}</h6>
              </b-col>

              <b-col cols="2"> </b-col>
            </b-row>
          </b-col>

          <b-col cols="12">
            <component
              :is="scrollbarTag"
              ref="scroll"
              class="scroll-area--data-list-add-new-productGroup-add"
              :settings="settings"
              :key="$vs.rtl"
            >
              <b-row
                v-for="(item, index) in items"
                :id="item.stockProductGroupId"
                :key="item.stockProductGroupId"
                ref="row"
              >
                <!-- Item Name -->
                <b-col cols="7" style="padding-right: 0">
                  <b-form-group label-for="cost">
                    <b-form-input
                      v-model="item.code"
                      style="font-size: inherit"
                      id="cost"
                      type="text"
                      @keyup.enter="addProductGroup(index)"
                      :placeholder="$t('ProductGroup')"
                      :disabled="item.disabled"
                    />
                  </b-form-group>
                </b-col>

                <!-- Quantity -->

                <b-col v-if="!isMobile()" style="padding-right: 0" cols="2" class="mb-50">
                  <b-row v-if="item.stockProductGroupId == ''">
                    <b-col style="padding: 0">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="addProductGroup(index)"
                      >
                        <Icon
                          color="#28c76f"
                          icon="ic:baseline-save-all"
                          width="20"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row v-else>
                    <b-col style="padding: 0; max-width: max-content">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="
                          isSidebarActiveProcess = true;
                          deleteProductGroupInd = index;
                        "
                      >
                        <Icon
                          color="#EA5455"
                          icon="ic:baseline-remove-circle"
                          width="20"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                    <b-col style="padding: 0; max-width: max-content">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="updateProductGroup(index)"
                      >
                        <Icon
                          color="#7367F0"
                          icon="material-symbols:select-check-box"
                          width="20"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col v-else style="padding-right: 0" cols="2" class="mb-50">
                  <b-row v-if="item.stockProductGroupId == ''">
                    <b-col style="padding: 0">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="addProductGroup(index)"
                      >
                        <Icon
                          color="#28c76f"
                          icon="ic:baseline-save-all"
                          width="20"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row v-else>
                    <b-col style="padding: 0; max-width: max-content">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="
                          isSidebarActiveProcess = true;
                          deleteProductGroupInd = index;
                        "
                      >
                        <Icon
                          color="#EA5455"
                          icon="ic:baseline-remove-circle"
                          width="18"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                    <b-col style="padding: 0; max-width: max-content">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="updateProductGroup(index)"
                      >
                        <Icon
                          color="#7367F0"
                          icon="material-symbols:select-check-box"
                          width="18"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
                <!-- Remove Button -->
                <b-col cols="12" style="height: 5px"> </b-col> </b-row
            ></component>
          </b-col>
        </b-row>

        <!-- Row Loop -->
      </b-form>
    </div>
    <vs-prompt
      :title="$t('Warning')"
      :acceptText="$t('Submit')"
      :cancelText="$t('Cancel')"
      @accept="deleteProductGroup"
      :active.sync="isSidebarActiveProcess"
      color="danger"
    >
      <div style="text-align: center" class="con-exemple-prompt">
        <span>
          <b-row style="margin-top: 15px">
            <b-col cols="12" align-self="center">
              <h6>{{ $t("DoConfirm") }}</h6>
            </b-col>
          </b-row>
        </span>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import { uuid } from "vue-uuid";
import { isMobile } from "mobile-device-detect";
import { Icon } from "@iconify/vue2";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  props: {
    data: {
      default: () => {},
    },
  },
  data() {
    return {
      deleteProductGroupInd: null,
      isSidebarActiveProcess: false,
      isMobile: function () {
        return isMobile;
      },
      searchedValue: "",
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      items: [
        {
          id: 0,
          code: "",
          disabled: false,
          stockProductGroupId: "",
        },
      ],
    };
  },
  components: {
    Icon,
    VuePerfectScrollbar,
  },
  watch: {
    stockGroupExpertize(val) {
      this.getProductGroupList();
      return val;
    },
    data(val) {
      return val;
    },
  },
  methods: {
    deleteProductGroupFunc(data) {
      const vs = this.$vs;
      this.$store
        .dispatch("stock/deleteStockProductGroupForExpertize", data.stockProductGroupId)
        .then((response) => {
					console.log(response)
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.$emit("getProductGroupsList");
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data[0].value.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },

    deleteProductGroup() {
      this.deleteProductGroupFunc(this.items[this.deleteProductGroupInd]);
    },
    getProductGroupList() {
      this.items = [
        {
          id: 0,
          code: "",
          disabled: false,
          stockProductGroupId: "",
        },
      ];
      let allProductGroupsData = this.stockGroupExpertize;
      allProductGroupsData.forEach((val, index) => {
        this.items.push({
          id: index + 1,
          code: val.ProductGroupName,
          disabled: false,
          stockProductGroupId: val.ProductGroupId,
        });
      });
    },
    submitProductGroup(data) {
      var createdId = uuid.v4();
      const vs = this.$vs;
      const obj = {
        productGroupId:
          data.stockProductGroupId != "" ? data.stockProductGroupId : createdId,
        productGroupName: data.code,
      };
      if (data.stockProductGroupId != "") {
        this.$store
          .dispatch("stock/updateStockProductGroupForExpertize", obj)
          .then((response) => {
            if (response.status == 200) {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });

              this.$emit("getProductGroupsList");
            } else {
              vs.notify({
                text: response.data[0].value.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          })
          .catch((error) => {
            return new Promise((resolve, reject) => {
              resolve(false);
            });
          });
      } else {
        delete obj.id;
        this.$store
          .dispatch("stock/addStockProductGroupForExpertize", obj)
          .then((response) => {
            if (response.success == true) {
              vs.notify({
                text: response.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.$emit("getProductGroupsList");
            } else {
              vs.notify({
                text: response.data.message.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          })
          .catch((error) => {
            return new Promise((resolve, reject) => {
              resolve(false);
            });
          });
      }
    },
    addProductGroup(ind) {
      this.submitProductGroup(this.items[ind]);
    },
    updateProductGroup(ind) {
      this.submitProductGroup(this.items[ind]);
    },
    clearFields() {
      this.items = [
        {
          id: 0,
          code: "",
          disabled: false,
          stockProductGroupId: "",
        },
      ];
    },
  },
	mounted() {
		this.getProductGroupList();
		
	},
  computed: {
    stockGroupExpertize: {
      get() {
        return this.$store.state.stock.StockGroupExpertize;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
};
</script>
<style lang="scss" scoped>
.scroll-area--data-list-add-new-productGroup-add {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 230px);

  &:not(.ps) {
    overflow-y: auto;
  }

	padding: 0px 30px 30px;
}
.con-vs-dialog {
  z-index: 520055;
}
</style>
